export const TRANSLATE_PAYMENT_METHOD = {
  credit: 'Crédito',
  debit: 'Débito',
  pix: 'Pix',
  googlepay: 'Google Pay',
  applepay: 'Apple Pay',
  c2p: 'Click To Pay',
} as const;
